import { type RefObject, useEffect, useRef } from 'react';

import { isOmniEmbedEvent, type OmniEmbedEvent } from './omniEmbedProtocol';

type UseOmniEmbedEventsOptions = {
  iframeRef: RefObject<HTMLIFrameElement | null>;
  origin: string | null;
  onEvent: (event: OmniEmbedEvent) => void;
};

// gloss
const useOmniEmbedEvents = ({ iframeRef, origin, onEvent }: UseOmniEmbedEventsOptions) => {
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (!origin) return;

    const listener = (event: MessageEvent) => {
      if (event.origin !== origin) return;
      const frameWindow = iframeRef.current?.contentWindow;
      if (!frameWindow || event.source !== frameWindow) return;
      if (!isOmniEmbedEvent(event.data)) return;
      onEventRef.current(event.data);
    };

    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, [iframeRef, origin]);
};

export type { UseOmniEmbedEventsOptions };
export { useOmniEmbedEvents };
